/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../../../SharedModules/services/service';

export const dispatchAllRebateProgramCode = (data) => {
  return {
    type: actionTypes.GET_ALL_REBATE_PROGRAMS,
    payload: data,
  };
};

export const getRebateProgramCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => {
      return dispatch(dispatchAllRebateProgramCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllRebateProgramCode(response.date));
    });
};

export const setSuspendedDtData = (data) => {
  return {
    type: actionTypes.SET_SUSPENDED_DT_DATA,
    payload: data,
  };
};

export const dispatchCheckLogData = (data) => {
  return {
    type: actionTypes.CHECKLOG_DATA,
    payload: data,
  };
};

export const setErrorMessages = (data) => {
  return {
    type: actionTypes.SET_ERROR_MESSAGES,
    payload: data,
  };
};

export const dispatchCheckLog = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.CHECKLOG, values)
    .then((response) => {
      return dispatch(dispatchCheckLogData(response.data));
    })
    .catch((response) => {
      dispatch(dispatchCheckLogData({ error: 'API failed' }));
    });
};

export const resetRemoveSuspendedDateStore = () => {
  return {
    type: actionTypes.RESET_REMOVE_SUSPENDED_DATE_STORE,
  };
};
